import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _AuxLiquidationItems } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { TaxPositionEditor } from "../../NationalizationProcessGeneralInfo/TaxPosition/TaxPositionEditor";


interface Props {
    IDAuxLiquidation: number;
}

export const AuxLiquidationItems = ({ IDAuxLiquidation }: Props) => {

    const liquidationitems = useDataBean(_AuxLiquidationItems);

    const single = Singleton.getInstance();
    const [accountemployee, setaccountemployee] = useState<any>(_single.getAccountID());
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDAuxLiquidation])

    const getLista = () => {

        liquidationitems.instance.getAuxLiquidationItemsCatalogPorPropiedades({ State: 1, IDAuxLiquidation: IDAuxLiquidation }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const validation = () => {
        const bean = liquidationitems.bean;

        if (!bean.FobValue || isNaN(bean.FobValue)) {
            toast.error("El Valor Fob es obligatorio y debe ser numérico");
            return false;
        }

        if (!bean.TaxNumber) {
            toast.error("Debe seleccionar una subpartida arancelaria");
            return false;
        }

        if (!bean.TaxNameArticle) {
            toast.error("El nombre del impuesto al artículo es obligatorio");
            return false;
        }

        if (!bean.Quantity || isNaN(bean.Quantity)) {
            toast.error("La cantidad del artículo es obligatoria y debe ser numérica");
            return false;
        }

        return true;
    };

    const create = () => {
        liquidationitems.setBean({
            State: 1,
            IDAuxLiquidation: IDAuxLiquidation,
            IDEmployee: _single.getAccountID(),
            Since: _single.getCurrenDate
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        liquidationitems.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        liquidationitems.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDAuxLiquidationItems', visible: true },
        { title: 'Valor Fob', property: 'FobValue', visible: true },
        { title: 'Subpartida arancelaria', property: 'TaxNumber', visible: true },
        { title: 'Nombre del impuesto al articulo', property: 'TaxNameArticle', visible: true },
        { title: 'Cantidad del articulo', property: 'Quantity', visible: true },
        { title: 'Fecha del registro', property: 'Since', visible: true },
        { title: 'Estado del registro', property: 'State', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit() && liquidationitems.bean && accountemployee === liquidationitems.bean.IDEmployee, evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={liquidationitems.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={() => {
                    if (validation()) {
                        editaItem();
                    }
                }}>

                    <div className="row">
                        <div className="col-md-12">
                            <label>Valor Fob</label>
                            <input type="text" name="FobValue" className="form-control" value={liquidationitems.bean.FobValue} onChange={liquidationitems.handleChange} />

                        </div>
                        <div className="col-md-6">

                            <label>Subpartida arancelaria</label>
                            <TaxPositionEditor render={liquidationitems.bean.TaxCode} idSelector={liquidationitems.bean.TaxNumber} onChange={(e) => { liquidationitems.setBean({ ...liquidationitems.bean, "TaxNumber": e.IDTaxPosition, "TaxCode": e.TaxCode }) }} label=" " returnType="Object" />
                        </div>
                        <div className="col-md-6">
                            <label>Nombre del impuesto al articulo</label>
                            <input type="text" name="TaxNameArticle" className="form-control" value={liquidationitems.bean.TaxNameArticle} onChange={liquidationitems.handleChange} />

                        </div>
                        <div className="col-md-12">
                            <label>Cantidad del articulo</label>
                            <input type="text" name="Quantity" className="form-control" value={liquidationitems.bean.Quantity} onChange={liquidationitems.handleChange} />

                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}